import { installService } from './InstallService.ts'
import { widgetWrapper } from '../wrapper/WidgetWrapper.ts'
import { mobileTemplate } from '../template/MobileTemplate.ts'
import {IParams} from "../types/params.interface.ts";
import {LanguageShortCodeType} from "../types/language-short-code.type.ts";
import {getCurrentLang} from "../utils.ts";
class TranslateService {
	inProgress = false
	current: LanguageShortCodeType = null
	params: IParams
	gtWidget: Element
	buttonsList: Record<string, HTMLOptionElement>

	setParams (params: IParams) {
		this.params = params
		this.current = this.params.siteLanguage
	}

	setGTWidget (GTwidget: Element) {
		this.gtWidget = GTwidget;
		const options = GTwidget.querySelectorAll('option')
		this.buttonsList = {};
		[...options].forEach(option => {
			this.buttonsList[option.value] = option
		})
	}

	autoTranslate(time: number, lang: LanguageShortCodeType){
		this.current = lang
		let cb = () => widgetWrapper.render().addListeners()
		
		installService.setCB(cb)
		installService.setAutoInstall(time)
	}

  private getCookieDomain(host: string) {
    const ROOTS = ['natvita.pl', 'natvita.com.pl', 'rekiny.wroclaw.pl', 'natvita-sklep-prod.rekiny.wroclaw.pl', 'natvita-sklep-prod-b2b.rekiny.wroclaw.pl','localhost:8080']
    for (const root of ROOTS) if (host === root || host.endsWith('.' + root)) return '.' + root
    return host 
  }
  private clearGoogTrans() {
    const domain = this.getCookieDomain(location.hostname)
    document.cookie = `googtrans=; path=/; Max-Age=0`
    document.cookie = `googtrans=; path=/; domain=${domain}; Max-Age=0`
  }
  private setGoogTrans(siteLang: string, lang: string) {
    const domain = this.getCookieDomain(location.hostname)
    this.clearGoogTrans()
    document.cookie = `googtrans=/${siteLang}/${lang}; path=/; domain=${domain}; Max-Age=31536000; SameSite=Lax${location.protocol==='https:'?'; Secure':''}`
  }

	translate (
		event: Event,
		element: Element,
		lang: LanguageShortCodeType
	) {
		if(!lang) return
		if(installService.inProgress) return
		if(this.inProgress) return

		if(!installService.installed){
			let cb = () => {this.translate(event, element, lang)}
			installService.setCB(cb)
			installService.install()
			return
		}
		
		if(lang === getCurrentLang()) return;
		if(lang === this.params.siteLanguage) {
			// document.querySelector('.skiptranslate').querySelector('iframe').contentDocument.querySelectorAll('button')[3].click()
			// mobileTemplate.open = false
			// widgetWrapper.render().addListeners()

			// Clear subdomain cookie first
				// 1. Try clearing it without domain
			this.clearGoogTrans()
      window.location.href = `${location.pathname}?SubmitCurrency=1&id_currency=1`
		} else {
			// this.gtWidget.value = lang
			// const event = new Event('change')
			// this.gtWidget.dispatchEvent(event)
			// this.inProgress = true
			// setTimeout(() => {
			// 	this.inProgress = false
			// 	mobileTemplate.open = false
			// 	widgetWrapper.render().addListeners()
			// Clear subdomain cookie first
				// 1. Try clearing it without domain
 			this.setGoogTrans(this.params.siteLanguage, lang)
      window.location.href = `${location.pathname}?SubmitCurrency=1&id_currency=2`
			// }, 1000)
		}
	}
}

const translateService = new TranslateService()

const shouldTranslateFromCookie = (): boolean => {
  const m = /(?:^|;\s*)googtrans=\/([^/]+)\/([^;]+)/.exec(decodeURIComponent(document.cookie));
  if (!m) return false;
  const dst = m[2];
  const siteLang = (translateService as any).params?.siteLanguage;
  return !!dst && !!siteLang && dst !== siteLang;
};

const ensureGTInstalled = () => {
  if (shouldTranslateFromCookie()) {
    if (installService.installed) {
      widgetWrapper.render().addListeners();
    } else if (!installService.inProgress) {
      installService.install();
    }
  }
};


window.addEventListener('pageshow', ensureGTInstalled);
window.addEventListener('popstate', ensureGTInstalled);

export {
	TranslateService,
	translateService
}
